import React, { useRef, useEffect, useState, useContext } from "react";
import styled from "styled-components";
import moment from "moment";
import { PDFExport } from "@progress/kendo-react-pdf";
import { SimpleTooltip } from "simple-ui-components";

import GetAppIcon from "@mui/icons-material/GetApp";
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";

import { CardHeader, CardBody } from "../../theme";
import { AuthContext } from "../authContextProvider";
import { ReplaceWord } from "../shared/utility";
import { useWindowSize } from "../layout/otherPage";
import { getTranslation } from "../languageProvider";

const PageTemplate = (props) => {
  return (
    <PDFFooterStyled>
      <span
        style={{
          fontFamily: "os-light",
          color: "rgba(0,0,0,0.5)",
          fontSize: 8,
          position: "absolute",
          bottom: 0,
          right: 10,
        }}
      >
        {getTranslation("0101") &&
          ReplaceWord(
            getTranslation("0101"),
            "**PAGE**",
            props.pageNum,
            "**PAGES**",
            props.totalPages
          )}
      </span>
      <span
        style={{
          fontFamily: "os-light",
          color: "rgba(0,0,0,0.5)",
          fontSize: 8,
          position: "absolute",
          bottom: 0,
          left: 10,
        }}
      >
        {getTranslation("0100")}: {moment(new Date()).format("YYYY-MM-DD")}
      </span>
      <span
        style={{
          fontFamily: "os-light",
          color: "rgba(0,0,0,0.3)",
          fontSize: 10,
          textAlign: "center",
          lineHeight: 1,
        }}
      >
        {getTranslation("0098")}
        <br /> {getTranslation("0099")}
        <a href="www.hexa.services" target="_blank">
          www.hexa.services
        </a>
        .
      </span>
    </PDFFooterStyled>
  );
};

const PDFFooterStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    position:absolute;
    display:flex;
    align-items: center;
    justify-content: center;
    flex-direction:column;
    bottom:10px;
    left:0;
    width:100%;
    border-top:1px solid rgba(${current.black}, 0.0625);
    `;
  }}
`;
export const PdfContainer = (props) => {
  const componentRef = useRef();

  const { Tooltip } = SimpleTooltip;

  const { boxHeight } = useWindowSize();

  const { appUser } = useContext(AuthContext);

  const [download, setDownload] = useState(false);
  const [documentName, setDocumentName] = useState("");

  const generateReportClickHandler = () => {
    document.querySelectorAll(".hideInPDF").forEach((el) => el.remove());
    setDownload(true);
  };
  useEffect(() => {
    if (download) {
      componentRef.current.save();
      setDownload(false);
    }
  }, [download]);

  useEffect(() => {
    if (appUser) {
      let company = appUser.company && appUser.company.name;
      setDocumentName(
        company.split(" ").join("") +
          "_" +
          moment(new Date()).format("YYYY-MM-DD")
      );
    }
  }, [appUser]);
  return (
    <>
      <CardHeader>
        <ChromeReaderModeIcon className="mainIcon" />
        <div className="detail" data-translate="0075">
          {getTranslation("0075")}
        </div>
        <Tooltip text={getTranslation("0097")} placement="left">
          <GetAppIcon onClick={generateReportClickHandler} />
        </Tooltip>
      </CardHeader>
      <CardBody height={boxHeight}>
        <PDFExportStyled>
          <PDFExport
            pageTemplate={PageTemplate}
            paperSize="A4"
            margin={{ left: 4, right: 4, top: 15, bottom: 20 }}
            fileName={`${documentName}.pdf`}
            forcePageBreak=".page-break"
            ref={componentRef}
          >
            <OtherInformationStyled className="otherInformation">
              <span className="title" data-translate="0096">
                {getTranslation("0096")}
              </span>
              {appUser && appUser.company && appUser.company.logo && (
                <img src={appUser.company.logo} alt={appUser.company.name} />
              )}
              {appUser && appUser.company && (
                <span className="companyName">{appUser.company.name}</span>
              )}
            </OtherInformationStyled>
            {props.children}
            {props.serviceOrders.length > 0 && (
              <ServiceOrdersStyled className="otherInformation page-break">
                <b>{getTranslation("0169")}:</b>
                <ul>
                  {props.serviceOrders.map((order) => (
                    <li key={order.id}>
                      <a
                        href={order.filename}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {order.originalFilename}
                      </a>
                    </li>
                  ))}
                </ul>
              </ServiceOrdersStyled>
            )}
          </PDFExport>
        </PDFExportStyled>
      </CardBody>
    </>
  );
};

const ServiceOrdersStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    padding:${current.gMD}!important;
    >ul{
      padding-left:${current.gXL};
      margin-top: ${current.gSM};
      >li{
        list-style: decimal;
        margin-bottom: ${current.gSM};
      }
    }
      `;
  }}
`;

const PDFExportStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
        >div>div.otherInformation{
            display:none;
        }
        >div>div.deviceInformation{
          .remove{
            display:none!important;
            width:18px;
            height:18px;
            color:rgba(${current.black},0.5);
            cursor:pointer;
          }
          :hover{
            .remove{
              display:block!important;
              :hover{
                color:rgb(${current.red});
              }
            }
          }
            textarea{
                border:1px solid rgba(${current.black}, 0.0625)!important;
                padding:${current.gMD}!important;
                width:calc(100% - 20px);
            }
        }
        `;
  }}
`;
const OtherInformationStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
        display:flex;
        flex-direction:column;
        margin-bottom:${current.gMD};
        padding:${current.gXL};
        height:800px;
        justify-content: center;
        align-items: center;
        .title{
            font-size:26px;
            font-family: "os-bold"!important;
            padding-bottom: 25px;
        }
        .companyName{
            font-size:22px;
            font-family: "os-sBold"!important;
        }
        .generateAt{
            margin-top:${current.gMD};
            font-size:10px;
            color:rgba(${current.black},0.5);
            font-family: "os-light"!important;
        }
        >img{
            width:250px;
            padding-bottom: 25px;
        }
    `;
  }}
`;
